import React, { Component } from 'react';
import DayTarget from './DayTarget';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import SnackbarContent from '@material-ui/core/SnackbarContent';


class WeekBlock extends Component {





    calcDayValue = (week, day) => {
        return (7 * (week - 1)) + day
    }

    checkBlankDisplayLesson = (week, day, lessons) => {
        return lessons.map(lesson => {
            if (lesson.WeekNum === week && lesson.DayOfWeek === day) {
                return (
                    <SnackbarContent key={lesson.lesson_id} style={{ backgroundColor: '#DDDDDD', maxWidth: '100%', minWidth: '90%', color: 'black', fontSize: '12px' }}
                        message={<div>{lesson.LessonName} <p style={{ fontSize: '10px' }}>{lesson.module_id ? lesson.module_name : null}</p></div>}
                    />
                )
            }
        })
    }

    render() {
        const { month, mappedLessons } = this.props
        // console.log(this.props)
        let weekStart = (month * 4) - 3
        let weekEnd = (month * 4) + 1
        let schedule = []

        for (let i = weekStart; i < weekEnd; i++) {
            schedule.push(
                <TableRow key={i}>
                    {/* <TableCell key={i + '_' + 1} style={{ margin: 0, padding: 5 }}><DayTarget mappedLessons={mappedLessons} month={month} week={i} day={1} dayValue={this.calcDayValue(i, 1)} weekend={true} /></TableCell> */}
                    <TableCell key={i + '_' + 2} style={{ margin: 0, padding: 5, borderRight: '1px solid lightgrey', borderLeft: '1px solid lightgrey' }}><DayTarget mappedLessons={mappedLessons} month={month} week={i} day={2} dayValue={this.calcDayValue(i, 2)} /></TableCell>
                    <TableCell key={i + '_' + 3} style={{ margin: 0, padding: 5, borderRight: '1px solid lightgrey' }}><DayTarget mappedLessons={mappedLessons} month={month} week={i} day={3} dayValue={this.calcDayValue(i, 3)} /></TableCell>
                    <TableCell key={i + '_' + 4} style={{ margin: 0, padding: 5, borderRight: '1px solid lightgrey' }}><DayTarget mappedLessons={mappedLessons} month={month} week={i} day={4} dayValue={this.calcDayValue(i, 4)} /></TableCell>
                    <TableCell key={i + '_' + 5} style={{ margin: 0, padding: 5, borderRight: '1px solid lightgrey' }}><DayTarget mappedLessons={mappedLessons} month={month} week={i} day={5} dayValue={this.calcDayValue(i, 5)} /></TableCell>
                    <TableCell key={i + '_' + 6} style={{ margin: 0, padding: 5, borderRight: '1px solid lightgrey' }}><DayTarget mappedLessons={mappedLessons} month={month} week={i} day={6} dayValue={this.calcDayValue(i, 6)} /></TableCell>
                    {/* <TableCell key={i + '_' + 7} style={{ margin: 0, padding: 5 }}><DayTarget mappedLessons={mappedLessons} month={month} week={i} day={7} dayValue={this.calcDayValue(i, 7)} weekend={true} /></TableCell> */}
                </TableRow>
            )
        }

        let nonDrag = []
        for (let i = weekStart; i < weekEnd; i++) {
            nonDrag.push(
                <TableRow key={i}>
                    {/* <TableCell key={i + '_' + 1} style={{ margin: 0, padding: 5 }}>{this.checkBlankDisplayLesson(i, 1, mappedLessons)}</TableCell> */}
                    <TableCell key={i + '_' + 2} style={{ margin: 0, padding: 5, borderRight: '1px solid lightgrey', borderLeft: '1px solid lightgrey'}}>{this.checkBlankDisplayLesson(i, 2, mappedLessons)}</TableCell>
                    <TableCell key={i + '_' + 3} style={{ margin: 0, padding: 5, borderRight: '1px solid lightgrey'}}>{this.checkBlankDisplayLesson(i, 3, mappedLessons)}</TableCell>
                    <TableCell key={i + '_' + 4} style={{ margin: 0, padding: 5, borderRight: '1px solid lightgrey'}}>{this.checkBlankDisplayLesson(i, 4, mappedLessons)}</TableCell>
                    <TableCell key={i + '_' + 5} style={{ margin: 0, padding: 5, borderRight: '1px solid lightgrey'}}>{this.checkBlankDisplayLesson(i, 5, mappedLessons)}</TableCell>
                    <TableCell key={i + '_' + 6} style={{ margin: 0, padding: 5, borderRight: '1px solid lightgrey'}}>{this.checkBlankDisplayLesson(i, 6, mappedLessons)}</TableCell>
                    {/* <TableCell key={i + '_' + 7} style={{ margin: 0, padding: 5 }}>{this.checkBlankDisplayLesson(i, 7, mappedLessons)}</TableCell> */}
                </TableRow>
            )
        }

        return (
            <Table>
                <TableHead>
                    <TableRow>
                        {/* <TableCell>Sunday</TableCell> */}
                        <TableCell  >Monday</TableCell>
                        <TableCell>Tuesday</TableCell>
                        <TableCell>Wednesday</TableCell>
                        <TableCell>Thursday</TableCell>
                        <TableCell>Friday</TableCell>
                        {/* <TableCell>Saturday</TableCell> */}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.props.detail ? nonDrag : schedule}
                </ TableBody>
            </Table>
        )
    }
}

export default WeekBlock;


// WEBPACK FOOTER //
// src/main/content/course/scheduleComponents/FourWeekBlock.js